import { useState } from 'react';
import { connect } from 'react-redux';
import { fetchPermissions } from 'actions/permissions';
import { fetchPackageStatuses } from 'actions/packageStatuses';
import { fetchTransferStatuses } from 'actions/transferStatuses';

let _content = null;

const StaffSelection = (props) => {
  const { state } = props.location;
  const switchStaff = state ? state.switchStaff : 0;

  const [staffLogin, setStaffLogin] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState({});

  const selectionHandler = (staff = {}) => {
    setStaffLogin(true);
    setSelectedStaff(staff);
  };

  return (
    _content &&
    _content({
      staffLogin,
      selectedStaff,
      switchStaff,
      props,
      selectionHandler,
    })
  );
};

const mapStateToProps = (state) => {
  return {
    staffs: state.staffs.staffs,
    error: state.staffs.error,
    currentStaff: state.staffs.currentStaff,
    currentStore: state.stores.currentStore,
  };
};

const mapDispatchToProps = {
  fetchPermissions,
  fetchPackageStatuses,
  fetchTransferStatuses,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(StaffSelection);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/staffSelection/index.js